import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import {resetPasswordActions} from "../../slice/resetPasswordSlise";


interface IResetPasswordProps {
    token: string | null;
    password: string;
    retypePassword: string;
}

export const resetPassword = createAsyncThunk<void, IResetPasswordProps>(
    'password/reset',
    async (resetData, thunkAPI) => {
        try {
            const response = await axios.post('/api/restore-password/reset', resetData);
            thunkAPI.dispatch(resetPasswordActions.setPasswordData(response.data));
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue({ error: "Ошибка при сбросе пароля" });
        }
    }
);